import React from 'react';
import { NavLink } from 'react-router-dom';

const BlogDetailsLayout = ({ blogData }) => {
    return (
      <>
      <style jsx global>{`
        /* Anchor Links */
        a {
          color: #007bff; /* Bootstrap Primary */
          text-decoration: none;
          transition: color 0.3s ease, border-bottom 0.3s ease;
        }
        a:hover {
          color: #0056b3;
          border-bottom: 1px solid #0056b3;
        }
        h2 {
          font-size: clamp(1.5rem, 4.5vw + 0.8rem, 2rem);
          font-weight: 600;
        }
        h3 {
          font-size: clamp(1rem, 4vw + 0.5rem, 1.5rem);
          font-weight: 600;
        }
        h4 {
          font-size: clamp(0.75rem, 3.5vw + 0.3rem, 1rem);
          font-weight: 600;
        }
        h5 {
          font-size: clamp(0.5rem, 3vw + 0.2rem, 0.75rem);
          font-weight: 600;
        }
        h6 {
          font-size: clamp(0.5rem, 2vw + 0.2rem, 0.5rem);
          font-weight: 600;
        }
      `}</style>

        <section
          className=""
          style={{
            backgroundImage: `url('assets/img/service/serviceD.jpg')`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
          id="service-sec"
        >
          <div className="round-container pt-5">
            <div className="container">
              <div className="title-area text-center">
                <span className="sub-title text-white">BLOG</span>
                <h1 className="sec-title text-white">{blogData.title}</h1>
              </div>
            </div>
          </div>
        </section>
        <section className="th-blog-wrapper blog-details space-top space-extra-bottom">
          <div className="container">
            <div className="row">
              {blogData.toc?.length > 0 && (
                <div className="mobile-toc d-lg-none">
                  <div className="mobile-toc-inner">
                    <h2>Table of Contents</h2>
                    <ul className="list-unstyled mb-0">
                      {blogData.toc.map((item) => (
                        <li key={item.id} className="mb-1">
                          <a href={`#${item.id}`} className="toc-link">
                            {item.text}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
              <style>
                {
                  `
                  .mobile-toc {
                    background: rgba(255, 255, 255, 0.9);
                    backdrop-filter: blur(6px);
                    border-radius: 12px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
                    padding: 16px;
                    margin-bottom: 20px;
                    position: sticky;
                    top: 80px; /* adjust if you have a fixed header */
                    z-index: 10;
                  }

                  .mobile-toc-inner h2 {
                    font-size: 1.25rem;
                    font-weight: 600;
                    margin-bottom: 12px;
                    color: #333;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 6px;
                  }

                  .mobile-toc-inner ul {
                    padding-left: 0;
                    margin: 0;
                  }

                  .mobile-toc-inner li {
                    margin-bottom: 8px;
                  }

                  .mobile-toc-inner .toc-link {
                    display: block;
                    padding: 6px 10px;
                    border-radius: 6px;
                    text-decoration: none;
                    font-size: 0.95rem;
                    transition: background 0.3s, color 0.3s;
                    color: #007bff;
                    background-color: #f1f1f1;
                    padding-left: 4px;
                    border-left: 3px solid #007bff;
                  }

                  

                  `
                }
              </style>

            </div>
            <div className="row">
              <div className="col-xxl-8 col-lg-8">
                <div className="th-blog blog-single">
                  {blogData.mainImage && (
                    <div className="blog-img">
                      <img src={blogData.mainImage} loading="lazy" alt="Blog" />
                    </div>
                  )}
                  <div className="blog-content">
                    <div className="blog-meta">
                      {blogData.authorImage && blogData.author && (
                        <a
                          className="author"
                          href=""
                          onClick={(event) => event.preventDefault()}
                        >
                          <img
                            src={blogData.authorImage}
                            loading="lazy"
                            alt="Author"
                          />
                          By {blogData.author}
                        </a>
                      )}
                      {blogData.date && (
                        <a href="" onClick={(event) => event.preventDefault()}>
                          <i className="fa-light fa-calendar-days"></i>
                          {blogData.date}
                        </a>
                      )}
                      {/* <a href="" onClick={(event) => event.preventDefault()}>
                        <i className="fa-regular fa-comments"></i>
                        Comments ({blogData.comments?.length || 0})
                      </a> */}
                    </div>
                    {/* <h2 className="blog-title">{blogData.title}</h2> */}
                    {blogData.content && (
                      <div
                        dangerouslySetInnerHTML={{ __html: blogData.content }}
                      ></div>
                    )}

                    {blogData.faqs && blogData.faqs.length > 0 && (
                    <div className="faq-section mt-4">
                      <h2 className="mb-2">Frequently Asked Questions</h2>
                      <div className="accordion" id="faqAccordion">
                        {blogData.faqs.map((faq, index) => (
                          <div className="accordion-item" key={index}>
                            <h2 className="accordion-header" id={`heading${index}`}>
                              <button
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#collapse${index}`}
                                aria-expanded="false"
                                aria-controls={`collapse${index}`}
                              >
                                {faq.question}
                              </button>
                            </h2>
                            <div
                              id={`collapse${index}`}
                              className="accordion-collapse collapse"
                              aria-labelledby={`heading${index}`}
                              data-bs-parent="#faqAccordion"
                            >
                              <div className="accordion-body">{faq.answer}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                  <style jsx>{`
                  .accordion-button {
                    transition: none !important;
                    box-shadow: none !important;
                  }

                  .accordion-button:not(.collapsed),
                  .accordion-button:focus {
                    box-shadow: none !important;
                  }
                `}</style>
                  </div>
                  {(blogData.tags && blogData.tags.length > 0) ||
                  (blogData.comments && blogData.comments.length > 0) ? (
                    <div className="share-links clearfix">
                      <div className="row justify-content-between">
                        {/* {blogData.tags && blogData.tags.length > 0 && (
                          <div className="col-sm-auto">
                            <span className="share-links-title">Tags:</span>
                            <div className="tagcloud">
                              {blogData.tags.map((tag, index) => (
                                <a
                                  key={index}
                                  href=""
                                  onClick={(event) => event.preventDefault()}
                                >
                                  {tag}
                                </a>
                              ))}
                            </div>
                          </div>
                        )} */}
                        <div className="col-sm-auto text-xl-end">
                          <span className="share-links-title">Share:</span>
                          <ul className="social-links">
                            <li>
                              <a
                                href="https://www.facebook.com/share/1E5k3uqY3x/"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <i className="fab fa-facebook-f"></i>
                              </a>
                            </li>
                            <li>
                              <a
                                href="https://www.instagram.com/warrgyiz_morsch?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <i className="fab fa-instagram"></i>
                              </a>
                            </li>
                            <li>
                              <a
                                href="https://www.linkedin.com/company/warrgyiz-morsch/posts/?feedView=all"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <i className="fab fa-linkedin-in"></i>
                              </a>
                            </li>
                            <li>
                              <a
                                href="https://api.whatsapp.com/send/?phone=%2B918693085077&text&type=phone_number&app_absent=0"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <i className="fab fa-whatsapp"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
                {/* {blogData.comments && blogData.comments.length > 0 && (
                  <div className="th-comments-wrap">
                    <h2 className="blog-inner-title h3">
                      <i className="far fa-comments"></i>
                      Comments ({blogData.comments.length})
                    </h2>
                    <ul className="comment-list">
                      {blogData.comments.map((comment, index) => (
                        <li key={index} className="th-comment-item">
                          <div className="th-post-comment">
                            <div className="comment-avater">
                              <img
                                src={comment.authorImage}
                                loading="lazy"
                                alt="Comment Author"
                              />
                            </div>
                            <div className="comment-content">
                              <span className="commented-on">
                                <i className="fal fa-calendar-alt"></i>
                                {comment.date}
                              </span>
                              <h3 className="name">{comment.author}</h3>
                              <p className="text">{comment.text}</p>
                              <div className="reply_and_edit">
                                <a
                                  href=""
                                  onClick={(event) => event.preventDefault()}
                                  className="reply-btn"
                                >
                                  <i className="fas fa-reply"></i>Reply
                                </a>
                              </div>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                <div className="th-comment-form">
                  <div className="form-title">
                    <h3 className="blog-inner-title mb-2">
                      <i className="fa-solid fa-reply"></i>
                      Leave a Comment
                    </h3>
                    <p className="form-text">
                      Your email address will not be published. Required fields
                      are marked *
                    </p>
                  </div>
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <input
                        type="text"
                        placeholder="Your Name*"
                        className="form-control"
                      />
                      <i className="fal fa-user"></i>
                    </div>
                    <div className="col-md-6 form-group">
                      <input
                        type="text"
                        placeholder="Your Email*"
                        className="form-control"
                      />
                      <i className="fal fa-envelope"></i>
                    </div>
                    <div className="col-12 form-group">
                      <input
                        type="text"
                        placeholder="Website"
                        className="form-control"
                      />
                      <i className="fal fa-globe"></i>
                    </div>
                    <div className="col-12 form-group">
                      <textarea
                        placeholder="Write a Comment*"
                        className="form-control"
                      ></textarea>
                      <i className="fal fa-pencil"></i>
                    </div>
                    <div className="col-12 form-group mb-0">
                      <button type="submit" className="th-btn">
                        Post Comment
                      </button>
                    </div>
                  </div>
                </div> */}
              </div>
              <div className="col-xxl-4 col-lg-4">
                <aside className="sidebar-area">
                  {blogData.toc?.length > 0 && (
                    <div className="p-3 bg-light rounded shadow-sm mb-4 d-none d-lg-block">
                      <h3 className="mb-3">Table of Contents</h3>
                      <ul className="list-unstyled toc-list">
                        {blogData.toc.map(item => (
                          <li key={item.id} className="mb-2">
                            <a href={`#${item.id}`} className="toc-link">
                              {item.text}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  <style jsx>{`
                  .toc-link {
                    display: block;
                    padding: 6px 10px;
                    border-radius: 6px;
                    text-decoration: none;
                    font-size: 0.95rem;
                    transition: background 0.3s, color 0.3s;
                    color: #007bff;
                    background-color: #f1f1f1;
                    padding-left: 4px;
                    border-left: 3px solid #007bff;
                  }

                  .toc-link:hover {
                    color: #000; /* Bootstrap primary */
                    background-color: #f1f1f1;
                    padding-left: 4px;
                    border-left: 3px solid #007bff;
                  }

                  .blog-content h1,
                  .blog-content h2,
                  .blog-content h3,
                  .blog-content h4,
                  .blog-content h5,
                  .blog-content h6 {
                    scroll-margin-top: 180px; /* Adjust based on your actual header height */
                  }


                `}</style>
                  
                  {blogData.recentPosts && blogData.recentPosts.length > 0 && (
                    <div className="widget widget_recent_entries">
                      <h3 className="widget_title">Recent Posts</h3>
                      <div className="recent-posts">
                        {blogData.recentPosts.map((post) => (
                          <div key={post.id} className="recent-post">
                            <div className="media-img">
                              <a
                                href=""
                                onClick={(event) => event.preventDefault()}
                              >
                                <img
                                  src={post.image}
                                  loading="lazy"
                                  alt={post.title}
                                />
                              </a>
                            </div>
                            <div className="recent-post-body">
                              <h4 className="post-title">
                                <NavLink
                                  className="text-inherit"
                                  to={`${post.url}`}
                                >
                                  {post.title}
                                </NavLink>
                              </h4>
                              <div className="recent-post-meta">
                                <a
                                  href=""
                                  onClick={(event) => event.preventDefault()}
                                >
                                  <i className="fal fa-calendar-days"></i>
                                  {post.date}
                                </a>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {blogData.categories && blogData.categories.length > 0 && (
                    <div className="widget widget_categories">
                      <h3 className="widget_title">Categories</h3>
                      <ul>
                        {blogData.categories.map((category, index) => (
                          <li key={index}>
                            <a
                              href={category.url}
                              onClick={(event) => event.preventDefault()}
                            >
                              {category.name}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  {/* {blogData.popularTags && blogData.popularTags.length > 0 && (
                    <div className="widget widget_tag_cloud">
                      <h3 className="widget_title">Popular Tags</h3>
                      <div className="tagcloud">
                        {blogData.popularTags.map((tag, index) => (
                          <a
                            key={index}
                            href=""
                            onClick={(event) => event.preventDefault()}
                          >
                            {tag}
                          </a>
                        ))}
                      </div>
                    </div>
                  )} */}
                </aside>
              </div>
            </div>
          </div>
        </section>
      </>
    );
}

export default BlogDetailsLayout;
